import React from "react";

const NotFoundPlaceHolder = ({
  title,
  description,
  placeHolderImage,
  className,
}) => {
  return (
    <div className={`content_placeholder ${className}`}>
      <img src={placeHolderImage} alt={`${title} place holder`} />
      <h3>{title || ""}</h3>
      {description && <p>{description || ""}</p>}
    </div>
  );
};

export default NotFoundPlaceHolder;
